var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitTotalTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63075 17.4915C6.48383 19.345 7.53464 20.8784 9.57497 21H14.4252C16.4665 20.8784 17.5164 19.345 17.3695 17.4915C17.2469 16.2052 16.0472 15.0328 13.9728 13.0411C13.3053 12.3464 13.3063 11.6526 13.9728 10.9579C16.0472 8.96627 17.2469 7.79481 17.3695 6.50854C17.5164 4.65503 16.4665 3.12162 14.4252 3H9.57497C7.53464 3.12162 6.48383 4.65503 6.63075 6.50854C6.75335 7.79481 7.95302 8.96627 10.0274 10.9579C10.6949 11.6526 10.6949 12.3464 10.0274 13.0411C7.95302 15.0328 6.75335 16.2052 6.63075 17.4915Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62305 17.9079C6.93829 18.0607 7.32456 18.1599 7.83829 18.1599C9.91656 18.1599 9.91656 16.5039 11.9958 16.5039C14.075 16.5039 14.075 18.1599 16.1543 18.1599C16.667 18.1599 17.0543 18.0607 17.3783 17.9079",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitTotalTime);
export default __webpack_public_path__ + "static/media/VisitTotalTime.b1f6c3471c3f5b74cbcc965d42e0bb26.svg";
export { ForwardRef as ReactComponent };